/** @format */

import {Table, TableCell, TableRow} from '@mui/material';
import {Trans} from 'react-i18next';

import {StyledTableBody, StyledTableContainer, StyledTableHead} from '../../styles';
import ShowTypeIcon from '../ShowTypeIcon';
import {AutoTargetingTableProps} from './interfaces';

const AutoTargetingTable = ({data}: AutoTargetingTableProps) => (
  <StyledTableContainer>
    <Table>
      <StyledTableHead>
        <TableRow>
          <TableCell>
            <Trans>Субаккаунт</Trans>
          </TableCell>
          <TableCell>
            <Trans>Тип кампании</Trans>
          </TableCell>
          <TableCell>
            <Trans>ID Кампании</Trans>
          </TableCell>
          <TableCell>
            <Trans>Название кампании</Trans>
          </TableCell>
          <TableCell>
            <Trans>ID Группы</Trans>
          </TableCell>
          <TableCell>
            <Trans>Название группы</Trans>
          </TableCell>
          <TableCell>
            <Trans>Ставка по автотаргетингу</Trans>
          </TableCell>
        </TableRow>
      </StyledTableHead>
      <StyledTableBody>
        {data.map((row, index) => (
          <TableRow key={index}>
            <TableCell>{row.subAccount}</TableCell>
            <TableCell>
              <ShowTypeIcon showType={row.showType} />
            </TableCell>
            <TableCell>{row.campaignId}</TableCell>
            <TableCell>{row.campaignName}</TableCell>
            <TableCell>{row.groupId}</TableCell>
            <TableCell>{row.groupName}</TableCell>
            <TableCell>{row.autoTargetingRate}</TableCell>
          </TableRow>
        ))}
      </StyledTableBody>
    </Table>
  </StyledTableContainer>
);

export default AutoTargetingTable;
